import React from 'react'
import { connect } from 'react-redux'
import TitleBar from '../components/TitleBar'
import Receipt from '../components/Receipt'
import GraphicArticle from '../components/GraphicArticle'
import ObjectItemOverview from '../objectmanagement/components/ObjectItemOverview'
import Menu from '../objectmanagement/components/Menu'

class ProductionPage extends React.Component {

    renderLayout(){  
        if(this.props.receiptnumber !== null && this.props.receiptnumber >= 0 && this.props.graphicdisplay) {
            return <GraphicArticle />
        } else {
            return <ObjectItemOverview />
        }
    }

    render() {
        
        return (
            <div id="app">
                <div id="main-container">
                    <TitleBar />
                    {this.renderLayout()}
                    <Menu />
                </div>
                <div id="receipt-keyboard-container" className="receipt-production">
                    <Receipt />
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        objectgroups: state.objectManagementState.objectgroups,
        selectedobjectgroup: state.objectManagementState.selectedobjectgroup,
        receiptnumber: state.receiptState.receipt.receiptnumber,
        graphicdisplay: state.generalState.graphicDisplay
    }
}

export default connect(mapStateToProps)(ProductionPage)



// WEBPACK FOOTER //
// src/pages/ProductionPage.jsx